/* eslint-disabled */

export default class AvenantTypeExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
